webpackJsonp([5],{

/***/ "Al6c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "C2di":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.b34809d.jpg";

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//

/* harmony default export */ var App = ({
  name: 'App'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b30bab42","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("Al6c")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/element-ui/lib/element-ui.common.js
var element_ui_common = __webpack_require__("zL8q");
var element_ui_common_default = /*#__PURE__*/__webpack_require__.n(element_ui_common);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/menu_components/Navbar.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var Navbar = ({
  name: 'navbar',
  components: {
    Menu: element_ui_common["Menu"],
    MenuItem: element_ui_common["MenuItem"]
  },
  data: function data() {
    return {
      /** - 默认激活的 index */
      link: 'home'
    };
  },
  mounted: function mounted() {
    /**
     * @description 获取当前页面需要激活的 index
     */
    this.link = window.location.href.slice(window.location.href.search('#') + 2);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c18cc20","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu_components/Navbar.vue
var Navbar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"top",attrs:{"id":"top"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"art-font"},[_vm._v("结盟连锁，全球首创")]),_vm._v(" "),_c('el-menu',{staticClass:"nav",attrs:{"mode":"horizontal","router":true,"default-active":_vm.link}},[_c('el-menu-item',{attrs:{"index":"home"}},[_vm._v("首页")]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"about"}},[_vm._v("关于我们")]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"cooperation"}},[_vm._v("创始合作")]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"contact"}},[_vm._v("联系我们")])],1),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2)],1)}
var Navbar_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":__webpack_require__("C2di"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('a',{attrs:{"target":"_banket","href":"http://www.eapor.com/"}},[_vm._v("登录")]),_vm._v("\n    /\n    "),_c('a',{attrs:{"target":"_banket","href":"http://www.eapor.com/home/client/useapplication.jsp"}},[_vm._v("注册")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact"},[_c('p',[_vm._v("客服加盟 021 - 57466066")])])}]
var Navbar_esExports = { render: Navbar_render, staticRenderFns: Navbar_staticRenderFns }
/* harmony default export */ var menu_components_Navbar = (Navbar_esExports);
// CONCATENATED MODULE: ./src/components/menu_components/Navbar.vue
function Navbar_injectStyle (ssrContext) {
  __webpack_require__("pI3U")
  __webpack_require__("kRrh")
}
var Navbar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Navbar___vue_template_functional__ = false
/* styles */
var Navbar___vue_styles__ = Navbar_injectStyle
/* scopeId */
var Navbar___vue_scopeId__ = "data-v-0c18cc20"
/* moduleIdentifier (server only) */
var Navbar___vue_module_identifier__ = null
var Navbar_Component = Navbar_normalizeComponent(
  Navbar,
  menu_components_Navbar,
  Navbar___vue_template_functional__,
  Navbar___vue_styles__,
  Navbar___vue_scopeId__,
  Navbar___vue_module_identifier__
)

/* harmony default export */ var components_menu_components_Navbar = (Navbar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/menu_components/AppMain.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var AppMain = ({
  name: 'AppMain'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02d31d9c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu_components/AppMain.vue
var AppMain_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"main-content"},[_c('transition',{attrs:{"name":"fade-transform"}},[_c('router-view')],1)],1)}
var AppMain_staticRenderFns = []
var AppMain_esExports = { render: AppMain_render, staticRenderFns: AppMain_staticRenderFns }
/* harmony default export */ var menu_components_AppMain = (AppMain_esExports);
// CONCATENATED MODULE: ./src/components/menu_components/AppMain.vue
function AppMain_injectStyle (ssrContext) {
  __webpack_require__("UzHT")
}
var AppMain_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AppMain___vue_template_functional__ = false
/* styles */
var AppMain___vue_styles__ = AppMain_injectStyle
/* scopeId */
var AppMain___vue_scopeId__ = "data-v-02d31d9c"
/* moduleIdentifier (server only) */
var AppMain___vue_module_identifier__ = null
var AppMain_Component = AppMain_normalizeComponent(
  AppMain,
  menu_components_AppMain,
  AppMain___vue_template_functional__,
  AppMain___vue_styles__,
  AppMain___vue_scopeId__,
  AppMain___vue_module_identifier__
)

/* harmony default export */ var components_menu_components_AppMain = (AppMain_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/menu_components/BottomContent.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var BottomContent = ({
  name: 'BottomContent'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7477628a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu_components/BottomContent.vue
var BottomContent_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var BottomContent_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"bottom-profile"},[_c('div',{staticClass:"log"},[_c('img',{attrs:{"src":__webpack_require__("C2di"),"height":"90"}}),_vm._v(" "),_c('span',[_vm._v("结盟连锁，全球首创")])]),_vm._v(" "),_c('div',{staticClass:"contact"},[_c('p',[_vm._v("\n        关于我们：客主酒店连锁隶属于上海客主网络科技有限公司，是致力于为酒店打造公平合理的经营环境的连锁酒店品牌。\n        "),_c('br'),_vm._v("\n        联系我们：上海市闵行区剑川路 951 号零号湾 2 号楼 3 楼；021 - 57466066\n        "),_c('br'),_vm._v("\n        版权所有：上海客主商务服务有限公司\n        "),_c('br'),_vm._v("\n        备 案 号："),_c('a',{attrs:{"target":"_blank","href":"http://www.miibeian.gov.cn/"}},[_vm._v("沪ICP备07024040号")])])])])])}]
var BottomContent_esExports = { render: BottomContent_render, staticRenderFns: BottomContent_staticRenderFns }
/* harmony default export */ var menu_components_BottomContent = (BottomContent_esExports);
// CONCATENATED MODULE: ./src/components/menu_components/BottomContent.vue
function BottomContent_injectStyle (ssrContext) {
  __webpack_require__("UNqy")
}
var BottomContent_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var BottomContent___vue_template_functional__ = false
/* styles */
var BottomContent___vue_styles__ = BottomContent_injectStyle
/* scopeId */
var BottomContent___vue_scopeId__ = "data-v-7477628a"
/* moduleIdentifier (server only) */
var BottomContent___vue_module_identifier__ = null
var BottomContent_Component = BottomContent_normalizeComponent(
  BottomContent,
  menu_components_BottomContent,
  BottomContent___vue_template_functional__,
  BottomContent___vue_styles__,
  BottomContent___vue_scopeId__,
  BottomContent___vue_module_identifier__
)

/* harmony default export */ var components_menu_components_BottomContent = (BottomContent_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/menu_components/Publicity.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Publicity = ({
  name: 'Publicity'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe61ec56","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu_components/Publicity.vue
var Publicity_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var Publicity_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"top-publicity"},[_c('p',{staticClass:"tip"},[_vm._v("\n    实体卡老平台用户\n    "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"http://k.kezhu.net","target":"_blanket"}},[_vm._v("点击这里")])]),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._v("\n     结盟连锁，创始第 1 期 100 酒店招募中————\n    "),_c('img',{attrs:{"src":__webpack_require__("OVUg"),"alt":""}})])])}]
var Publicity_esExports = { render: Publicity_render, staticRenderFns: Publicity_staticRenderFns }
/* harmony default export */ var menu_components_Publicity = (Publicity_esExports);
// CONCATENATED MODULE: ./src/components/menu_components/Publicity.vue
function Publicity_injectStyle (ssrContext) {
  __webpack_require__("tWXE")
}
var Publicity_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Publicity___vue_template_functional__ = false
/* styles */
var Publicity___vue_styles__ = Publicity_injectStyle
/* scopeId */
var Publicity___vue_scopeId__ = "data-v-fe61ec56"
/* moduleIdentifier (server only) */
var Publicity___vue_module_identifier__ = null
var Publicity_Component = Publicity_normalizeComponent(
  Publicity,
  menu_components_Publicity,
  Publicity___vue_template_functional__,
  Publicity___vue_styles__,
  Publicity___vue_scopeId__,
  Publicity___vue_module_identifier__
)

/* harmony default export */ var components_menu_components_Publicity = (Publicity_Component.exports);

// CONCATENATED MODULE: ./src/components/menu_components/index.js




// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Layout.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var Layout = ({
  name: 'Layout',
  components: {
    AppMain: components_menu_components_AppMain,
    BottomContent: components_menu_components_BottomContent,
    Navbar: components_menu_components_Navbar,
    Publicity: components_menu_components_Publicity
  },
  data: function data() {
    return {
      showPublicity: true,
      showTip: false,
      sTop: 0
    };
  },

  watch: {
    $route: function $route(to, from) {
      console.log(to.path);
      if (to.path === '/home') {
        this.showPublicity = true;
      } else {
        this.showPublicity = false;
      }
    }
  },
  mounted: function mounted() {
    window.addEventListener('scroll', this.showReturn, false);
  },

  methods: {
    /**
     * - 显示返回按钮
     */
    showReturn: function showReturn() {
      this.sTop = document.documentElement.scrollTop || document.body.scrollTop;

      if (this.sTop >= 570) {
        this.showTip = true;
      } else {
        this.showTip = false;
      }
    },

    /**
     * - 返回顶部
     */
    back: function back() {
      this.scrollTop(window, this.sTop, 0, 1000);
    },

    /**
     * - scrollTop animation
     */
    scrollTop: function scrollTop(el) {
      var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var to = arguments[2];
      var duration = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 500;
      var endCallback = arguments[4];

      if (!window.requestAnimationFrame) {
        window.requestAnimationFrame = window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
          return window.setTimeout(callback, 1000 / 60);
        };
      }
      var difference = Math.abs(from - to);
      var step = Math.ceil(difference / duration * 50);

      function scroll(start, end, step) {
        if (start === end) {
          endCallback && endCallback();
          return;
        }

        var d = start + step > end ? end : start + step;
        if (start > end) {
          d = start - step < end ? end : start - step;
        }

        if (el === window) {
          window.scrollTo(d, d);
        } else {
          el.scrollTop = d;
        }
        window.requestAnimationFrame(function () {
          return scroll(d, end, step);
        });
      }
      scroll(from, to, step);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3106f5c0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout.vue
var Layout_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"el-zoom-in-top"}},[(_vm.showPublicity)?_c('publicity'):_vm._e()],1),_vm._v(" "),_c('navbar'),_vm._v(" "),_c('appMain'),_vm._v(" "),_c('bottom-content'),_vm._v(" "),_c('transition',{attrs:{"name":"el-fade-in-linear"}},[(_vm.showTip)?_c('div',{attrs:{"id":"return-top"},on:{"click":_vm.back}},[_vm._v("返回顶部")]):_vm._e()])],1)}
var Layout_staticRenderFns = []
var Layout_esExports = { render: Layout_render, staticRenderFns: Layout_staticRenderFns }
/* harmony default export */ var components_Layout = (Layout_esExports);
// CONCATENATED MODULE: ./src/components/Layout.vue
function Layout_injectStyle (ssrContext) {
  __webpack_require__("vAQL")
}
var Layout_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Layout___vue_template_functional__ = false
/* styles */
var Layout___vue_styles__ = Layout_injectStyle
/* scopeId */
var Layout___vue_scopeId__ = "data-v-3106f5c0"
/* moduleIdentifier (server only) */
var Layout___vue_module_identifier__ = null
var Layout_Component = Layout_normalizeComponent(
  Layout,
  components_Layout,
  Layout___vue_template_functional__,
  Layout___vue_styles__,
  Layout___vue_scopeId__,
  Layout___vue_module_identifier__
)

/* harmony default export */ var src_components_Layout = (Layout_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js





vue_esm["default"].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  routes: [{
    path: '/',
    component: src_components_Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'Home',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("j7e0")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: 'about',
      name: 'About',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("vu9I")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: 'cooperation',
      name: 'Cooperation',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Z9bQ")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: 'contact',
      name: 'Contact',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Ccy0")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }]
  }]
}));
// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





vue_esm["default"].config.productionTip = false;
vue_esm["default"].use(element_ui_common_default.a);

/* eslint-disable no-new */
new vue_esm["default"]({
  el: '#app',
  router: router,
  components: { App: src_App },
  template: '<App/>'
});

/***/ }),

/***/ "OVUg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/click.663f5b2.png";

/***/ }),

/***/ "UNqy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UzHT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kRrh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pI3U":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tWXE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vAQL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.69d7b6efc5fd638b3ab8.js